import store from '../../store';
import Errors from '../../Errors';
import ProductRating from '../ProductRating.vue';
import ProductCardMixin from '../../mixins/ProductCardMixin';
import RelatedProducts from './show/RelatedProducts.vue';
import { trans } from '../../functions';

export default {
    components: { ProductRating, RelatedProducts },

    mixins: [
        ProductCardMixin,
    ],

    props: ['product', 'reviewCount', 'avgRating'],

    data() {
        return {
            price: this.product.formatted_price,
            activeTab: 'description',
            currentReviewPage: 1,
            fetchingReviews: false,
            reviews: {},
            addingNewReview: false,
            reviewForm: {},
            cartItemForm: {
                product_id: this.product.id,
                qty: 1,
                options: {},
                children: {},
            },
            idFieldArr: [],
            errorClassArr: [],
            valueIdArr: [],
            errors: new Errors(),
        };
    },

    computed: {
        totalReviews() {
            if (! this.reviews.total) {
                return this.reviewCount;
            }

            return this.reviews.total;
        },

        ratingPercent() {
            return (this.avgRating / 5) * 100;
        },

        emptyReviews() {
            return this.totalReviews === 0;
        },

        totalReviewPage() {
            return Math.ceil(this.reviews.total / 4);
        },
    },

    created() {
        this.fetchReviews();
    },

    mounted() {
        $(this.$refs.upSellProducts).slick({
            rows: 0,
            dots: false,
            arrows: true,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            rtl: window.Nya.rtl,
        });
    },

    methods: {
        updateQuantity(qty) {
            if (qty < 1 || this.exceedsMaxStock(qty)) {
                return;
            }

            if (isNaN(qty)) {
                qty = 1;
            }

            this.cartItemForm.qty = qty;
        },

        exceedsMaxStock(qty) {
            return this.product.manage_stock && this.product.qty < qty;
        },

        changeReviewPage(page) {
            this.currentReviewPage = page;

            this.fetchReviews();
        },

        updatePrice() {
            this.$nextTick(() => {
                $.ajax({
                    method: 'POST',
                    url: route('products.price.show', { id: this.product.id }),
                    data: { options: this.cartItemForm.options },
                }).then((price) => {
                    this.price = price;
                }).catch((xhr) => {
                    this.$notify(xhr.responseJSON.message);
                });
            });
        },

        updateSelectTypeOptionValue(option, e) {
            this.$set(this.cartItemForm.options, option['id'], $(e.target).val());

            for (let value of option['values']) {
                for (let children of value['children']) {
                    let error = 'children-' + children['id'];
                    this.errorClassArr = this.errorClassArr.filter(item => item != error);
                }
            }

            if($(e.target).val()) {
                for (let value of option['values']) {
                    if($(e.target).val() == value['id']) {
                        this.addChildrenValue(option['id'], value);
                    }
                }
            } else {
                $(`.option-${option['id']}-row-children`).html('');
            }

            this.errors.clear(`options.${option['id']}`);
        },

        updateCheckboxTypeOptionValue(optionId, e) {
            let values = $(e.target)
                .parents('.variant-check')
                .find('input[type="checkbox"]:checked')
                .map((_, el) => {
                    return el.value;
                });

            this.$set(this.cartItemForm.options, optionId, values.get());
        },

        customRadioTypeOptionValueIsActive(optionId, valueId) {
            if (! this.cartItemForm.options.hasOwnProperty(optionId)) {
                return false;
            }

            return this.cartItemForm.options[optionId] === valueId;
        },

        addChildrenValue(optionId, value) {
            let content = '';
            for (let children of value['children']) {
                this.idFieldArr.push(`children-${children['id']}`);
                this.valueIdArr.push(children['id']);
                let isRequired = children['is_required'] ? '<span>*</span>' : '';
                let error = 'children-' + children['id'];
                if(children['is_required']) {
                    this.errorClassArr.push(error);
                }

                if(children['type'] == 'field') {
                    let placeholder = children['placeholder'] || '';
                  
                    content += `
                    <div class="row mb-3">
                    <div class="col-md-4">
                        <label for="children-${children['id']}">
                        ${children['label']} ${isRequired}
                        </label>
                    </div>
    
                    <div class="col-md-8">
                        <div class="form-input">
                            <input
                                name="children[${children['id']}]"
                                class="form-control"
                                id="children-${children['id']}"
                                placeholder="${placeholder}"
                                maxlength="${children['max_length_text']}"
                            />
                        </div>

                        <span class="error-message ${error} mt-2">
                    </span>
    
                    </div></div>
                    `;
                } else {
                    let items = children['dropdown_menu'].split(",");
                    let contentDropdown = '';
                    for (let item of items) {
                        contentDropdown +=`                    
                            <option value="${item}">
                              ${item}
                            </option>
                        `;
                    }
                                                                
                    content += `
                    <div class="row mb-3">
                        <div class="col-md-4">
                            <label for="option-${children['id']}">
                            ${children['label']} ${isRequired}
                            </label>
                        </div>

                        <div class="col-md-8">
                            <div class="form-input">
                            <select
                            name="children[${children['id']}]"
                            class="form-control custom-select-option arrow-black"
                            id="children-${children['id']}"
                            @nice-select-updated="updateSelectTypeOptionValue(${children['id']}, $event)"
                        >
                        ${contentDropdown}
                        </select>

                        <span class="error-message ${error}">
                        </div>
                    </div></div>
                    `;
                }
            }

            $(`.option-${optionId}-row-children`).html(content);
        },

        syncCustomRadioTypeOptionValue(option, value) {
            if (this.customRadioTypeOptionValueIsActive(option['id'], value['id'])) {
                this.$delete(this.cartItemForm.options, option['id']);
            } else {
                this.$set(this.cartItemForm.options, option['id'], value['id']);
                this.errors.clear(`options.${option['id']}`);
                for (let value of option['values']) {
                    for (let children of value['children']) {
                        let error = 'children-' + children['id'];
                        this.errorClassArr = this.errorClassArr.filter(item => item != error);
                    }
                }

                this.addChildrenValue(option['id'], value);
            }

            this.updatePrice();
        },

        customCheckboxTypeOptionValueIsActive(optionId, valueId) {
            if (! this.cartItemForm.options.hasOwnProperty(optionId)) {
                this.$set(this.cartItemForm.options, optionId, []);

                return false;
            }

            return this.cartItemForm.options[optionId].includes(valueId);
        },

        syncCustomCheckboxTypeOptionValue(optionId, valueId) {
            if (this.customCheckboxTypeOptionValueIsActive(optionId, valueId)) {
                this.cartItemForm.options[optionId].splice(
                    this.cartItemForm.options[optionId].indexOf(valueId),
                    1
                );
            } else {
                this.cartItemForm.options[optionId].push(valueId);

                this.errors.clear(`options.${optionId}`);
            }

            this.updatePrice();
        },

        fetchReviews() {
            this.fetchingReviews = true;

            $.ajax({
                method: 'GET',
                url: route('products.reviews.index', {
                    productId: this.product.id,
                    page: this.currentReviewPage,
                }),
            }).then((reviews) => {
                this.reviews = reviews;
            }).catch((xhr) => {
                this.$notify(xhr.responseJSON.message);
            }).always(() => {
                this.fetchingReviews = false;
            });
        },

        addNewReview() {
            this.addingNewReview = true;

            $.ajax({
                method: 'POST',
                url: route('products.reviews.store', { productId: this.product.id }),
                data: this.reviewForm,
            }).then((review) => {
                this.reviewForm = {};
                this.reviews.total++;
                this.reviews.data.unshift(review);

                $('.captcha-input').prev('img').trigger('click');
            }).catch((xhr) => {
                if (xhr.status === 422) {
                    this.errors.record(xhr.responseJSON.errors);
                } else {
                    this.$notify(xhr.responseJSON.message);
                }
            }).always(() => {
                this.addingNewReview = false;
            });
        },

        addToCart() {
            let showButtonCount = 0;
            if(this.idFieldArr.length > 0) {
                for(let i = 0; i< this.idFieldArr.length; i++) {
                    if($(`#${this.idFieldArr[i]}`).length > 0 && $(`#${this.idFieldArr[i]}`)[0].value) {
                        this.$set(this.cartItemForm.children,  this.valueIdArr[i], $(`#${this.idFieldArr[i]}`)[0].value);
                    }
                }
            }

            for(let error of this.errorClassArr) {
                if($(`#${error}`)[0].value !='') {
                    $(`.${error}`).html('');
                } else {
                    $(`.${error}`).html(trans('nya::product.this_field_is_required'));
                    showButtonCount += 1;
                }
            }

            if(showButtonCount == 0) {
                this.addingToCart = true;
             
                $.ajax({
                    method: 'POST',
                    url: route('cart.items.store', this.cartItemForm),
                }).then((cart) => {
                    store.updateCart(cart);
    
                    $('.header-cart').trigger('click');
                }).catch((xhr) => {
                    if (xhr.status === 422) {
                        this.errors.record(xhr.responseJSON.errors);
                    } else {
                        this.$notify(xhr.responseJSON.message);
                    }
                }).always(() => {
                    this.addingToCart = false;
                });
            }
        },
    },
};
